import { Image, ImageProps } from 'expo-image';
import { StyleSheet } from 'react-native';

import { LtoContentUS } from '../lto-content/lto-content-us';

export type TopMarketingImageProps = Omit<ImageProps, 'children' | 'source'>;

export function TopMarketingImage(props: TopMarketingImageProps) {
  return (
    <LtoContentUS
      ltoContent={
        <Image
          source={require('./smokin-bbq-triple-stack.webp')}
          placeholder={{ thumbhash: 'sTgKJwjIpriKhndYl0d594h6jAVWWGAF' }}
          alt="Smokin' BBQ Triple Stack. Available in classic or New! Carolina Gold"
          contentFit="cover"
          {...props}
          style={[styles.marketingImage, props.style]}
        />
      }
      hotOnes={
        <Image
          source={require('./hot-ones.webp')}
          placeholder={{ thumbhash: '11mKDQI4h5iGiGT3OIiIoKkKaWdwhnyHSA' }}
          alt="Hot Ones"
          contentFit="cover"
          {...props}
          style={[styles.marketingImage, props.style]}
        />
      }
      default={
        <Image
          source={require('./hook-and-ladder.webp')}
          placeholder={{ thumbhash: '2lmKFYInl3hziXDat5hzYEsGJ0eEh4D4Zw' }}
          alt="Hook & Ladder"
          contentFit="cover"
          {...props}
          style={[styles.marketingImage, props.style]}
        />
      }
    />
  );
}

const styles = StyleSheet.create({
  marketingImage: {
    aspectRatio: 1600 / 1622,
    width: '96%',
    height: '96%',
    minHeight: 200,
    alignSelf: 'center',
  },
});
